import { render } from "./imageFooter.vue?vue&type=template&id=6ef94092&scoped=true"
import script from "./imageFooter.vue?vue&type=script&lang=js"
export * from "./imageFooter.vue?vue&type=script&lang=js"

import "./imageFooter.vue?vue&type=style&index=0&id=6ef94092&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ef94092"]])

export default __exports__